import { BannerAnalyticsData } from '@analytics/const';
import { Injectable } from '@angular/core';
import { AnalyticsService } from './analytics.service';

@Injectable({ providedIn: 'root' })
export class PromoAnalyticsService {
  constructor(private analyticsService: AnalyticsService) {}

  onShowBanner(data: BannerAnalyticsData): void {
    this.analyticsService.sendEcommerceEvent({
      event: 'view_promotion',
      ecommerce: {
        items: [
          {
            promotion_id: data.id,
            promotion_name: data.name,
            creative_slot: data.position,
          },
        ],
      },
    });
  }

  onClickBanner(data: BannerAnalyticsData): void {
    this.analyticsService.sendEcommerceEvent({
      event: 'select_promotion',
      ecommerce: {
        items: [
          {
            promotion_id: data.id,
            promotion_name: data.name,
            creative_slot: data.position,
          },
        ],
      },
    });
  }

  onApplyPromocode(promocode: string, status: string): void {
    this.analyticsService.sendEcommerceEvent({
      event: 'commonEvent_nf',
      eventCateg: 'Применить промокод в корзине',
      eventAction: promocode,
      eventLabel: status,
      eventNonInteraction: false,
    });
  }
}
